import { render, staticRenderFns } from "./CategoryTypeExtraPage.vue?vue&type=template&id=201454f2&scoped=true&"
import script from "./CategoryTypeExtraPage.vue?vue&type=script&lang=js&"
export * from "./CategoryTypeExtraPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTypeExtraPage.vue?vue&type=style&index=0&id=201454f2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201454f2",
  null
  
)

export default component.exports